module.exports = __webpack_public_path__ + "media/images/m-service-7ec0741d.png";